var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-content"},[_c('div',{staticClass:"news-title-wrap"},[_c('h2',{staticClass:"news-title wow fadeInUp"},[_vm._v(_vm._s(_vm.item.title))])]),_c('section',{staticClass:"content content-text wow fadeInUp",attrs:{"data-wow-delay":"0.5s"},domProps:{"innerHTML":_vm._s(_vm.cContent(_vm.item.content))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }